import React, {PropTypes} from 'react';
import { PageHeader, Row, Col, Grid, Image, Thumbnail } from 'react-bootstrap';
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';
// LOCAL
import ClientsTab from './ClientsTab'
import ProfileTab from './ProfileTab'
// import DiscountTab from './DiscountTab'
import AccountantProfileSaveAlertModal from './components/AccountantProfileSaveAlertModal'
// SHARED
import TabBarItem from '../core/components/TabBarItem';

export default class MainContentAccountants extends React.Component {
  state = {
    activeKey: "1"
  }

  onTabChange(activeKey) {
    this.setState({
      activeKey,
    });
  }

  changeTabsToTab(tab_key){
    this.setState({
      activeKey: tab_key,
    });
  }

  onTabClick(key) {
    if (key != this.state.activeKey) {
      this.setState({
        activeKey: key,
      });
    }
  }

  onCreatedAccountantGroupAlertOk(){
    this.props.handleCreatedAccountantGroupAlertOk()
    this.setState({
      activeKey: "1",
    });
  }

  render() {
    const { activeKey } = this.state
    const { clients, user, ui, onProfileFormSave, onClientTabComponentDidMount, onAccountantGroupFormReset } = this.props
    // return null

    const accountantGroup = user.group_as_accountant || {}

    return (
      <div className="main-content-component main-content-accountants">
        <PageHeader>Accountants Dashboard</PageHeader>
        <Grid className="main-container" fluid={true}>
          <Row className="show-grid">
            <Col className={accountantGroup && !accountantGroup.first_name ? "empty-state" : ""} xs={12} sm={12} md={12}>
              <Tabs
              defaultActiveKey="1"
              activeKey={activeKey}
              renderTabBar={()=><ScrollableInkTabBar onTabClick={this.onTabClick.bind(this)}/>}
              renderTabContent={()=><TabContent animated={false}
              onChange={this.onTabChange.bind(this)}
              />}
              >
                <TabPane tab={<TabBarItem title="Clients" imageClass="clients-tab-image" />} key="1">
                  <ClientsTab
                    onClientTabComponentDidMount={onClientTabComponentDidMount}
                    user={user}
                    clients={clients}
                    changeTabsToTab={this.changeTabsToTab.bind(this)}
                  />
                </TabPane>
                <TabPane tab={<TabBarItem title="Accountant Profile" imageClass="profile-tab-image" />} key="2">
                  <ProfileTab
                    onProfileFormSave={onProfileFormSave}
                    groupAsAccountant={user.group_as_accountant}
                    ui={ui}
                    onAccountantGroupFormReset={onAccountantGroupFormReset}
                  />
                </TabPane>

              </Tabs>
            </Col>
          </Row>
        </Grid>
        <AccountantProfileSaveAlertModal
          showModal={ui.createdAccountantGroupAlertModal.showModal}
          modalTitle={ui.createdAccountantGroupAlertModal.modalTitle}
          modalBody={ui.createdAccountantGroupAlertModal.modalBody}
          alertStyle={ui.createdAccountantGroupAlertModal.alertStyle}
          onOk={this.onCreatedAccountantGroupAlertOk.bind(this)}
          okButtonTitle={ui.createdAccountantGroupAlertModal.okButtonTitle}
          cancelButtonTitle={ui.createdAccountantGroupAlertModal.cancelButtonTitle}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/accountants/MainContentAccountants.js